var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFieldErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F00",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.699 14.883c.021 0 .09.034.108.034H14.72l.295.28-.203-.283c-.012-.015-.01-.098-.018-.115L7.764.739.733 14.8l-.037.084h.002m.024.738a.736.736 0 0 1-.415-.144.74.74 0 0 1-.168-1.036L7.14.428c.286-.57.96-.57 1.245 0l7.019 14.039a.744.744 0 0 1-.74 1.142l-13.858.004a.405.405 0 0 1-.084.008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.763 11.094a.348.348 0 0 1-.347-.348v-4.87a.348.348 0 0 1 .695 0v4.87a.348.348 0 0 1-.348.348M7.776 12.833a.526.526 0 0 1-.535-.505.523.523 0 0 1 .509-.538H7.779c.28.014.496.233.506.506a.52.52 0 0 1-.51.537"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldErrorIcon);
export default __webpack_public_path__ + "static/media/field-error-icon.4f313168.svg";
export { ForwardRef as ReactComponent };